import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { ResponseHelper } from 'src/app/shared/helpers/response.helper';
import { CommonResponse } from 'src/app/shared/models/reponse.model';
import { environment as env } from 'src/environments/environment';
import { LoginService } from '../../services/logIn.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { PageLoadingService } from 'src/app/shared/services/page-loading.service';
import { CountryService } from 'src/app/countries/services/country.service';

@Component({
  selector: 'app-request-qr-code',
  templateUrl: './request-qr-code.component.html',
  styleUrls: ['./request-qr-code.component.scss']
})
export class RequestQrCodeComponent implements OnInit {

  email: string = "";
  password: string = "";
  countryName: string = '';
  qrCodeSvgSafe: SafeHtml;
  showErrorMessages = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  private readonly requestQRObserver = {
    next: (data: CommonResponse<any>) => this.requestQRNext(data),
    error: (error: CommonResponse<any>) => this.requestQRError(error),
    complete: () => this._pageLoadingService.hideLoadingGif()
  };

  constructor(private _loginService: LoginService,
    private _snackbarService: SnackbarService,
    private _countryService: CountryService,
    private cdr: ChangeDetectorRef,
    private _sanitizer: DomSanitizer,
    private _pageLoadingService: PageLoadingService) { }

    ngOnInit() {
      const storedCountryName = localStorage.getItem('countryName');
      
      if (storedCountryName !== null) {
        this.countryName = storedCountryName;
        this._countryService.getCountryName$().subscribe(countryName => {
          this.countryName = countryName;
          this.cdr.detectChanges(); // Marcar la vista como actualizada
        });
      } else {
        this._countryService.getCountryName$().subscribe(countryName => {
          this.countryName = countryName;
          this.cdr.detectChanges(); // Marcar la vista como actualizada
        });
      }
    }

  requestQRNext(data: CommonResponse<any>) {
    if (ResponseHelper.responseDontHaveErrors(data)) {
      this.qrCodeSvgSafe = this._sanitizer.bypassSecurityTrustHtml(data.data.qrCode);
    }else{
      this._snackbarService.openStandardSnackBar(data.message);
    }

    this._pageLoadingService.hideLoadingGif();
  }

  requestQRError(error: CommonResponse<any>) {
    this._snackbarService.openStandardSnackBar('requestQRError');
    this._pageLoadingService.hideLoadingGif();
  }

  requestQrCode() {
    if (!this.isInvalidEmail() && !this.isInvalidPassword()) {

      this._pageLoadingService.showLoadingGif();

      let response: Observable<CommonResponse<any>> = this._loginService.getQrCodeAsSvg(this.email, this.password);
      response.subscribe(this.requestQRObserver);
    }
    else {
      this.showErrorMessages = true;
    }
  }

  isInvalidEmail() {
    let regExValidator = new RegExp("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$");
    return !regExValidator.test(this.email);
  }

  isInvalidPassword() {
    return this.password.length < env.password_min_length;
  }

}
